import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { OwlOptions, SlidesOutputData } from "ngx-owl-carousel-o";
import { CarouselComponent } from "ngx-owl-carousel-o";
import { NavigationService } from "src/app/providers/navigation.service";
@Component({
  selector: "sm-app-onboarding",
  templateUrl: "./app-onboarding.component.html",
  styleUrls: ["./app-onboarding.component.scss"],
})
export class AppOnboardingComponent implements OnInit {
  slides = [
    {
      image: "../assets/images/salon_onboard_owner_1.png",
      text: "Add your Salon, Beauty Parlor, Spa, Make-up Studio, Gym, Fitness and Yoga center. Control and get live data of your business from anywhere in the world. Perfect for business houses, as well for individual professionals.",
    },
    {
      image: "../assets/images/onbroding-nd.png",
      text: "Manage your customers, members, bookings, attendance - over Shop, Home or Virtual service. Create your service catalogue. Collaborate with your employees. See customer feedback, interact with them in real time.",
    },
    {
      image: "../assets/images/salon_onboard_owner_3.png",
      text: "Track your business expenses. Manage billings, taxes, discounts, inventory, purchase. Control service hours and availability. Get real time reports on sales, expenses, services, profit and loss, employee performance etc.",
    },
  ];

  currentIndex = 0;
  private startX = 0;
  private endX = 0;

  constructor(
    private router: Router,
    private navservice: NavigationService,
  ) {
    this.navservice.hideSidebarAndNav = true;
  }

  goToSlide(index: number) {
    this.currentIndex = index;
  }
  ngOnInit(): void {}
  onContinue() {
    this.router.navigate(["login"]);
  }

  onTouchStart(event: TouchEvent) {
    this.startX = event.touches[0].clientX;
  }

  onTouchMove(event: TouchEvent) {
    this.endX = event.touches[0].clientX;
  }

  onTouchEnd() {
    const diffX = this.startX - this.endX;
    if (Math.abs(diffX) > 50) {
      if (diffX > 0 && this.currentIndex < this.slides.length - 1) {
        this.currentIndex++;
      } else if (diffX < 0 && this.currentIndex > 0) {
        this.currentIndex--;
      }
    }
  }
}
